exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-04072292] {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  width: available;\n  border-collapse: collapse;\n  border: 3px solid #FFF;\n  margin: 10px 10px 0 10px;\n}\ntable th[data-v-04072292] {\n  text-transform: uppercase;\n  text-align: left;\n  background: rgb(13, 36, 84);\n  color: #FFF;\n  padding: 8px;\n  min-width: 30px;\n  border-right: 1px solid lightblue;\n  border-bottom: 1px solid lightblue;\n}\ntable span[data-v-04072292] {\n  color: white;\n}\ntable td[data-v-04072292] {\n  text-align: center;\n  padding: 8px;\n  border-right: 1px solid rgb(13, 36, 84);\n  border-bottom: 2px solid rgb(13, 36, 84);\n}\ntable td[data-v-04072292]:last-child {\n  border-right: none;\n}\ntable tbody tr:nth-child(2n) td[data-v-04072292] {\n  background: #D4D8F9;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-04072292","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/reports/ReportTable.vue
// module id = INk1
// module chunks = 70